import { configureStore } from "@reduxjs/toolkit";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";
import regionReducer from "./region/regionSlice"

export const store = configureStore({
  reducer: {
    region: regionReducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(createStateSyncMiddleware({})),
});
initMessageListener(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;